import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { X } from "lucide-react";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/80 backdrop-blur-sm"
        aria-hidden="true"
      />

      {/* Centered Modal */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="relative w-full max-w-sm card-glass p-6">
          <div className="flex justify-between">
            {/* Title */}
            <DialogTitle className="text-2xl font-bold text-white text-center pb-4">
              {title}
            </DialogTitle>

            {/* Close Button */}
            <button
              onClick={onClose}
              className="text-gray-300 hover:text-white pb-4"
              aria-label="Close Modal"
            >
              <X size={30} />
            </button>
          </div>

          {/* Content */}
          <div className="mt-4 text-gray-200">{children}</div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default Modal;
